import { BoxSlider, FadeSlider } from "@boxslider/slider";
// @link https://github.com/miloxeon/fast-image-zoom
import imageZoom from "fast-image-zoom";

const params = new URLSearchParams(window.location.search);

const OPTIONS = {
  autoScroll: false,
  timeout: 1000,
  speed: 400,
  swipe: true,
  swipeTolerance: 50,
};

let slider;
const box = document.querySelector("#slider");

const thumbs = document.querySelectorAll(".thumb");
thumbs[0].classList.add("current");

/**
 * MEDIA QUERY LIST
 * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_media_queries/Testing_media_queries
 */

const mediaQuery = window.matchMedia("(min-width: 769px)");

function handleScreenSize(mql) {
  if (mql.matches) {
    slider = initSlider();

    imageZoom({
      selector: ".artwork img",
      exceed: true,
      padding: 16
    })

  } else {
    box.classList.add("mobile");

    const observer = new IntersectionObserver(setOpacity, {
      root: null,
      rootMargin: "0px",
      threshold: [...Array(100).keys()].map(x => x / 100)
    });
    const targets = box.querySelectorAll("figure");
    targets.forEach((target) => {
      observer.observe(target)
    })

    function setOpacity(entries, observer) {
      entries.forEach((entry => {
        let ratio = entry.intersectionRatio;
        // if (ratio < 0.01) {
        //   ratio = 0;
        // }
        // if (ratio > 0.85) {
        //   ratio = 1;
        // }
        entry.target.style.setProperty("--op", entry.intersectionRatio)
      }))
    }
  }
}

handleScreenSize(mediaQuery);

/**
  SLIDER
*/

function initSlider() {
  const slider = new BoxSlider(box, new FadeSlider(), OPTIONS);

  slider.addEventListener("after", (data) => {
    updateCurrent(data.currentIndex);
  });

  addThumbsClickHandlers(thumbs);
  if (slider.slides.length <= 1) {
    const artNav = document.querySelectorAll(".art-nav");
    artNav.forEach((btn) => {
      btn.style.display = "none";
    })
  } else {
    addNavClickHandlers();
  }

  function addThumbsClickHandlers(index) {
    index.forEach((t) => {
      t.style.cursor = "pointer";
      t.addEventListener("click", (e) => {
        const target = e.target;
        const i = Number(target.getAttribute("data-index"));
        slider.skipTo(i);
      });
    });
  }

  function addNavClickHandlers() {
    const prevBtn = document.querySelector("#art-prev");
    const nextBtn = document.querySelector("#art-next");

    prevBtn.addEventListener("click", (e) => {
      slider.prev();
    })

    nextBtn.addEventListener("click", (e) => {
      slider.next();
    })
  }

  return slider;
}

function updateCurrent(i) {
  thumbs.forEach((t) => {
    Number(t.dataset.index) === i
      ? t.classList.add("current")
      : t.classList.remove("current");
  });
}

// UPDATE SLIDER WHEN OPENING WITH PARAM
if (params.has("work")) {
  const work = Number(params.get("work"));
  if (box.classList.contains("mobile")) {
    const targetArtwork = document.querySelector(`#artwork-${work}`);
    setTimeout(() => {
      targetArtwork.scrollIntoView({
        block: "center"
      })
    }, 200);
  } else {
    slider.skipTo(work).then(() => {
      updateCurrent(work);
    });
  }
}

// TOOLTIP

const tippyEmailContent = document.querySelector("#email-tooltip");
let copyButton;

if (tippyEmailContent) {
  const tippyEmailInstance = tippy('#email', {
    content: tippyEmailContent.innerHTML,
    allowHTML: true,
    interactive: true
  })

  copyButton = tippyEmailInstance[0].popper.querySelector("button");

  copyButton.addEventListener("click", (e) => {
    copyContent()
  })
  }

const copyContent = async () => {
  try {
    await navigator.clipboard.writeText(copyButton.dataset.content);
    console.log('Content copied to clipboard');
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
}

const tippyWebContent = document.querySelector("#web-tooltip");

if (tippyWebContent) {
  const tippyWebInstance = tippy('#web', {
    content: tippyWebContent.innerHTML,
    allowHTML: true,
    interactive: true
  })
}

const infotargets = document.querySelectorAll('.hasinfos')

console.log(infotargets);

infotargets.forEach((actu) => {
  const target = actu.querySelector('.infos');
  const content = actu.querySelector('.infos-content');
  console.log(content.innerHTML);
  tippy(target, {
    content: content.innerHTML,
    allowHTML: true,
    interactive: true
  })
})
